// src/utils/translations.js
const translations = {
    sr: {
        title: "Večiti Derbi",
        login: "Prijavi se sa Google nalogom",
        chooseTeam: "Izaberi tim",
        blackWhite: "Crno-beli",
        redWhite: "Crveno-beli",
        play: "Igraj",
        score: "Rezultat",
        myScore: "Moj ukupan rezultat",
        teamScore: "Rezultat tima",
        attempts: "Preostalo pokušaja",
        dailyAttempts: "Dnevni pokušaji",
        bonusAttempts: "Bonus pokušaji",
        buyAttempts: "Kupi pokušaje",
        shareLink: "Pozovi prijatelja (I osvoji 100 pokušaja)",
        copyLink: "Kopiraj link",
        linkCopied: "Link kopiran!",
        logout: "Odjavi se",
        clickToStop: "Klikni da zaustaviš lopte",
        hit: "POGODAK!",
        miss: "PROMAŠAJ!",
        noAttempts: "Nemate više pokušaja danas!",
        buyMore: "Kupite još pokušaja",
        option1: "100 pokušaja - 100 RSD",
        option2: "1100 pokušaja - 1000 RSD",
        paymentCode: "Kod za uplatu",
        paymentInstructions: "Uplatite na račun: USKORO",
        paymentNote: "Napomena pri uplati",
        close: "Zatvori",
        admin: "Admin panel",
        pendingPayments: "Čekaju odobrenje",
        approvePayment: "Odobri",
        language: "Jezik",
        teamLeading: "Vodi tim",
        speedIncrease: "Brzina povećana",
        generateCode: "Generiši kod",
        teamStats: "Statistika timova",
        todayScore: "Današnji rezultat",
        clickTwice: "Klikni dva puta - prvi put za vertikalnu, drugi put za horizontalnu loptu",
        registerTeamHelp: "Pomozi svom timu da pobedi danas!",
        blackWhiteTeam: "Crno beli",
        redWhiteTeam: "Crveno beli",
        pause: "Pauziraj",
        resume: "Nastavi",
        paused: "PAUZIRANO",
        sendShareLinkText: "Pošaljite link prijatelju i dobijte 100 bonus pokušaja kada se registruje!",
        myDailyScore: "Moj dnevni rezultat",
        checkPayment: "Proveri pokušaje",
        matchEndsIn: "Utakmica se završava za",
        matchResetMidnight: "Rezultati se resetuju u ponoć",
        refreshing: "Osvežavam",
        teamHistory: "Istorija tima",
        teamHistoryLast10Days: "Utakmice (poslednjih 10 dana)",
        total: "Ukupno",
        today: "Danas",
        yesterday: "Juče",
        live: "U toku",
        tie: "Nerešeno",
        noHistoryData: "Nema podataka o istoriji",
        errorLoadingHistory: "Greška pri učitavanju istorije",
        downloadAndroidApp: "Preuzmi Android Aplikaciju",
        playAnonymously: "Igraj anonimno na telefonu",
        orPlayAnonymously: "ili igraj anonimno"
    },
    en: {
        title: "Eternal Derby",
        login: "Sign in with Google",
        chooseTeam: "Choose team",
        blackWhite: "Black-white",
        redWhite: "Red-white",
        play: "Play",
        score: "Score",
        myScore: "My total score",
        teamScore: "Team score",
        attempts: "Attempts left",
        dailyAttempts: "Daily attempts",
        bonusAttempts: "Bonus attempts",
        buyAttempts: "Buy attempts",
        shareLink: "Invite friend (And get 100 new attempts)",
        copyLink: "Copy link",
        linkCopied: "Link copied!",
        logout: "Logout",
        clickToStop: "Click to stop balls",
        hit: "HIT!",
        miss: "MISS!",
        noAttempts: "No more attempts today!",
        buyMore: "Buy more attempts",
        option1: "100 attempts - 100 RSD",
        option2: "1100 attempts - 1000 RSD",
        paymentCode: "Payment code",
        paymentInstructions: "Pay to account: COMING SOON!",
        paymentNote: "Payment reference",
        close: "Close",
        admin: "Admin panel",
        pendingPayments: "Pending payments",
        approvePayment: "Approve",
        language: "Language",
        teamLeading: "Leading team",
        speedIncrease: "Speed increased",
        generateCode: "Generate code",
        teamStats: "Team statistics",
        todayScore: "Today's score",
        clickTwice: "Click twice - first for vertical, second for horizontal ball",
        registerTeamHelp: "Help your team win today!",
        blackWhiteTeam: "Crno beli",
        redWhiteTeam: "Crveno beli",
        pause: "Pause",
        resume: "Resume",
        paused: "PAUSED",
        sendShareLinkText: "Send the link to a friend and get 100 bonus attempts when they sign up!",
        myDailyScore: "My daily score",
        checkPayment: "Check attempts",
        matchEndsIn: "Match ends in",
        matchResetMidnight: "Scores reset at midnight",
        refreshing: "Refreshing",
        teamHistory: 'Team History',
        teamHistoryLast10Days: 'Team History (Last 10 Days)',
        total: 'Total',
        today: 'Today',
        yesterday: 'Yesterday',
        live: 'Live',
        tie: 'Tie',
        noHistoryData: 'No history data available',
        errorLoadingHistory: 'Error loading history',
        downloadAndroidApp: "Download Android App",
        playAnonymously: "Play anonymously on mobile",
        orPlayAnonymously: "or play anonymously"
    }
};

export default translations;